// NPM
import React, { useState, useEffect } from "react";
import _ from 'lodash';

// State
import { useDispatch } from 'react-redux';
import { setPartyOrder } from 'features/parties/partyOrderSlice';
import { useSelector } from 'react-redux';

// Services
import apiService from "services/apiService";

// Services
import renderService from 'services/renderService';

// Components
import VoteShareTile from './VoteShareTile';

function VoteShare() {
  const dispatch = useDispatch();
  const [voteShareData, setVoteShareData] = useState({});

  useEffect(() => loadData(), []);
  
  const loadData = async () => {
    const response = await fetch(apiService.apiURL("vote_share"));
    const jsonData = await response.json();
    setVoteShareData(jsonData);

    const orderedParties = _
      .chain(jsonData)
      .sortBy(datum => parseFloat(datum.median))
      .reverse()
      .map("party")
      .value()

    dispatch(setPartyOrder(orderedParties));
  }

  const partyOrder = useSelector(state => state.partyOrder.value);
  const campaignConfig = useSelector(state => state.campaignConfig.value);

  if(!renderService.canRender([campaignConfig, partyOrder])) {
    return null;
  }

  const title = _.get(campaignConfig, "sections.VoteShare.title");
  const description = _.get(campaignConfig, "sections.VoteShare.description");

  return (
    <div className="VoteShare Signal__section">
      { title && <h2 className="Signal__section-title">{ title }</h2> }
      { description && <p className="Signal__section-description">{ description }</p> }

      <div className="Signal__section-visualization">
        {
          _.sortBy(voteShareData, datum => parseFloat(datum.median)).reverse().map((voteShare, voteShareIndex) => {
            return (
              <VoteShareTile 
                key={ `VoteShare-${ voteShareIndex }` } 
                voteShare={ voteShare }
              />
            )
          })
        }
      </div>
    </div>
  )
}

export default VoteShare;